import { Injectable } from '@angular/core';
import { SanityProductVariation } from '@gelato-api-ui/core/sanity/sanity-product-variation';

@Injectable({ providedIn: 'root' })
export class SanityContentAvailabilityService {
  isProductControlOptionSelected(productControlOptions: string[], selectedProductVariation: SanityProductVariation) {
    if (productControlOptions?.length > 0 && selectedProductVariation) {
      return productControlOptions.some(option => {
        const [key, value] = option.split(':');
        return selectedProductVariation[key] === value;
      });
    }
    return true;
  }
}
